<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      子画面定義：OIDC用利用規約画面(STDSCM04C05)  ログイン時、利用規約未同意で表示                                       _/
     _/                                                                                                                    _/
     _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
     <template>
        <BaseModal :show="isTermsServiceShow">
          <div class="popup rule">
            <div class="popup-head">利用規約</div>
            <div class="popup-body blue">
              <div class="frm-row">
                <!-- <textarea
                      class="frm-text frm-size-full"
                      rows="22"
                      disabled="disable"
                    ></textarea> -->
                <div class="preview-area-TearmsOfService">
                  <iframe
                    v-bind:src="requiredTermsOfUseUrl"
                    width="100%"
                    height="400px"
                  ></iframe>
                </div>
              </div>
              <div class="frm-row">
                <ToggleButton
                  tabindex="1"
                  ref="toggleBtn"
                  v-model="clause"
                  :list="[
                    { code: 0, text: '上記の条項に同意します' },
                    { code: 1, text: '上記の条項に同意しません' },
                  ]"
                />
              </div>
              <div class="frm-btn-row">
                <div class="frm-item grow left">
                  <button
                    class="frm-btn strong large"
                    type="button"
                    tabindex="2"
                    @click="close"
                  >
                    終了
                  </button>
                </div>
                <div class="frm-item grow right">
                  <button
                    class="frm-btn strong large"
                    type="button"
                    @click="confirm"
                    :disabled="isDisabled"
                    tabindex="2"
                  >
                    確定
                  </button>
                </div>
              </div>
            </div>
          </div>
        </BaseModal>
      </template>
      
      <script>
      import { mapMutations, mapGetters } from "vuex";
      import _ from "lodash";
      import BaseModal from "@/components/Base/BaseModal.vue";
      import ToggleButton from "@/components/ToggleButton.vue";
      
      export default {
        name: "STDSCM04C04TearmsOfService",
        data() {
          return {
            clause: 1,
          };
        },
        components: { BaseModal, ToggleButton },
        props: {
          requiredTermsOfUseUrl: {
            type: String,
            required: true,
          },
        },
        watch: {
          isTermsServiceShow: function (newVal) {
            if (newVal) {
              this.$nextTick(function () {
                this.initFocus();
              });
            }
          },
        },
        computed: {
          ...mapGetters("businessModule", ["isTermsServiceShow"]),
          // **********************************************
          // 確認ボタン非活性、活性
          // **********************************************
          isDisabled() {
            return this.clause == 0 ? false : true;
          },
        },
        methods: {
          ...mapMutations("businessModule", ["termsServiceDialogue"]),
          // **********************************************
          // チェックボックスを変更したときの処理
          // **********************************************
          handleClause(e) {
            this.clause = e.target.value;
          },
          // **********************************************
          // 確認ボタンをクリック
          // **********************************************
          confirm() {
            this.$emit("confirm");
          },
          // **********************************************
          //  終了ボタンをクリック
          // **********************************************
          close() {
            this.clause = 1;
            this.$emit("close")
          },
          // **********************************************
          // 初期フォーカス設定
          // **********************************************
          initFocus() {
            this.$refs.toggleBtn.focus();
          },
        },
      };
      </script>
      
      <style scoped>
      .rule {
        width: 1000px;
      }
      </style>
      